/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/payment/formbox-header/payment-formbox-header.component';
const styles_FormboxHeaderComponent:any[] = ([] as any[]);
export const RenderType_FormboxHeaderComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_FormboxHeaderComponent,data:{}});
export function View_FormboxHeaderComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'header',[['class',
      'checkout-formbox-header']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(2,
      0,(null as any),(null as any),0,'i',([] as any[]),[[8,'className',0]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted(3,(null as any),
      ['\n    ','\n']))],(null as any),(_ck,_v) => {
    var _co:i1.FormboxHeaderComponent = _v.component;
    const currVal_0:any = i0.ɵinlineInterpolate(1,'fa ',_co.icon,' mr-xs');
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = _co.title;
    _ck(_v,3,0,currVal_1);
  });
}
export function View_FormboxHeaderComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'payment-formbox-header',
      ([] as any[]),(null as any),(null as any),(null as any),View_FormboxHeaderComponent_0,
      RenderType_FormboxHeaderComponent)),i0.ɵdid(1,49152,(null as any),0,i1.FormboxHeaderComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const FormboxHeaderComponentNgFactory:i0.ComponentFactory<i1.FormboxHeaderComponent> = i0.ɵccf('payment-formbox-header',
    i1.FormboxHeaderComponent,View_FormboxHeaderComponent_Host_0,{title:'title',icon:'icon'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNzI3MDEzMDEyL3NyYy9zcmMvYXBwL3BheW1lbnQvZm9ybWJveC1oZWFkZXIvcGF5bWVudC1mb3JtYm94LWhlYWRlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vY29kZWJ1aWxkL291dHB1dC9zcmM3MjcwMTMwMTIvc3JjL3NyYy9hcHAvcGF5bWVudC9mb3JtYm94LWhlYWRlci9wYXltZW50LWZvcm1ib3gtaGVhZGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNzI3MDEzMDEyL3NyYy9zcmMvYXBwL3BheW1lbnQvZm9ybWJveC1oZWFkZXIvcGF5bWVudC1mb3JtYm94LWhlYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNzI3MDEzMDEyL3NyYy9zcmMvYXBwL3BheW1lbnQvZm9ybWJveC1oZWFkZXIvcGF5bWVudC1mb3JtYm94LWhlYWRlci5jb21wb25lbnQudHMuRm9ybWJveEhlYWRlckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxoZWFkZXIgY2xhc3M9XCJjaGVja291dC1mb3JtYm94LWhlYWRlclwiPlxuICAgIDxpIGNsYXNzPVwiZmEge3tpY29ufX0gbXIteHNcIj48L2k+XG4gICAge3t0aXRsZX19XG48L2hlYWRlcj4iLCI8cGF5bWVudC1mb3JtYm94LWhlYWRlcj48L3BheW1lbnQtZm9ybWJveC1oZWFkZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtNQUFBLGdCQUF3Qyw4Q0FDcEM7TUFBQTtNQUFBLDRDQUFpQztNQUFBOztJQUE5QjtJQUFILFdBQUcsU0FBSDtJQUFpQztJQUFBOzs7O29CQ0RyQztNQUFBO3VDQUFBLFVBQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/$$_gendir/app/payment/formbox-header/payment-formbox-header.component.ngfactory.ts